<!-- eslint-disable vue/require-v-for-key -->
<template lang="html">
  <div id="parentx">
    
    <vs-sidebar
      default-index="1"
      :parent="parent"
      :hiddenBackground="doNotClose"
      color="primary"
      class="sidebarx"
      spacer
      v-model="isSidebarActive"
      :click-not-close="doNotClose"
    >
      <div class="header-sidebar text-center" slot="header" @click="profilePopup = true">
        <vs-avatar v-if="appUser.image" size="75px" :src="image" />
        <vs-avatar v-else size="70px" :src="require('@/assets/images/users/3.png')" />
        <h4>
          {{ appUser.name }}<br/>
          <small>{{ appUser.email }}</small>
        </h4>
      </div>
      <template v-for="(sidebarLink, index) in sideBars">
        <vs-sidebar-item
          :icon="sidebarLink.icon"
          :to="sidebarLink.url"
          :key="`sidebarLink-${index}`"
          :index="index"
          v-if="sidebarLink.hardrefresh == undefined"
        >
          <span class="hide-in-minisidebar">{{ sidebarLink.name }}</span>
        </vs-sidebar-item>
        <div v-else class="vs-sidebar--item"><a :href="sidebarLink.url"><i class="vs-icon notranslate icon-scale material-icons null">{{sidebarLink.icon}}</i><span class="hide-in-minisidebar">Post Settings</span></a></div>
      </template>
      <div @click="logoutPopup = true">
        <vs-sidebar-item icon="exit_to_app">
          <span class="hide-in-minisidebar">Logout</span>
        </vs-sidebar-item>
      </div>
      <div class="footer-sidebar" slot="footer">
        <small class="small-text">Powered by saaslabs.in</small>
      </div>
    </vs-sidebar>
    <vs-popup class="holamundo" :title="action + ' Profile'" :active.sync="profilePopup">
      <edit-profile @profileUpdated="reset" @closeEdit="profilePopup=false"></edit-profile>
      </vs-popup>
    <vs-popup
      class="holamundo"
      small
      title="Logout?"
      :active.sync="logoutPopup"
    >
      <p>Are you sure you want to Logout?</p>
      <div>
        <vs-button @click="logout">Logout</vs-button>
        <vs-button
          color="grey"
          style="margin-left: 15px;"
          @click="logoutPopup = false"
          >Cancel</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import router from "../../../router";
import EditProfile from "../../../views/components/main/editProfile.vue";
import { API } from "../../../common/constants";
export default {
  name: "SideBar",
  props: {
    parent: {
      type: String,
    },
    sidebarLinks: {
      type: Array,
      required: true,
    },
    index: {
      default: null,
      type: [String, Number],
    },
  },
  components: {
    EditProfile
  },
  data: () => ({
    profilePopup: false,
    action: "View",
    logoutPopup: false,
    doNotClose: false,
    windowWidth: window.innerWidth,
    user: {}
  }),
  computed: {
    sideBars() {
        return this.$props.sidebarLinks;
    },
    image() {
        return API.API_BASE.substring(0, API.API_BASE.lastIndexOf('/')) + '/' + this.appUser.image;
    },
    //This is for mobile trigger
    isSidebarActive: {
      get() {
        return this.$store.state.isSidebarActive;
      },
      set(val) {
        this.$store.commit("IS_SIDEBAR_ACTIVE", val);
      },
    },
    appUser() {
      return JSON.parse(localStorage.user);
    },
  },
  watch: {    
    'localStorage.user'(){
      this.user = JSON.parse(localStorage.user);
    }
  },
  methods: {
    reset(){
      this.$forceUpdate()
    },
    logout() {
      this.$data.logoutPopup = false;
      router.push("/logout");
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebar();
    },
    setSidebar() {
      if (this.windowWidth < 1170) {
        this.$store.commit("IS_SIDEBAR_ACTIVE", false);
        this.doNotClose = false;
      } else {
        this.$store.commit("IS_SIDEBAR_ACTIVE", true);
        this.doNotClose = true;
      }
    },
  },
  mounted() {

    this.user = JSON.parse(localStorage.user); 
    
    // this.$nextTick(() => {
    //   window.addEventListener("resize", this.handleWindowResize);
    // });
    // this.setSidebar();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
    this.setSidebar();
  },
};
</script>
<style scoped>
.footer-sidebar {
  text-align: center;
  height: 40px;
  padding: 10px 0px;
}
.small-text {
  font-size: 12px;
}
</style>
